import React, { SyntheticEvent, useState } from 'react'
import { Icon, Select } from '@toctoc/design-system'
import { Paper, Tab, Tabs } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { selectFilter, setOrder } from 'src/app/reducers/filters'
import styled from '@emotion/styled'
import styles from "./Select.module.scss";
import { separadorDeMiles } from '@/utils/separadorDeMiles'

const orderByOptions = [
	{
		"label": "Relevantes",
		"value": '1'
	},
	{
		"label": "Precio menor a mayor",
		"value": '2'
	},
	{
		"label": "Precio mayor a menor",
		"value": '3'
	},
	// {
	// 	"label": "Superficie menor a mayor",
	// 	"value": '4'
	// },
	// {
	// 	"label": "Superficie mayor a menor",
	// 	"value": '5'
	// },
	{
		"label": "Recientes",
		"value": '6'
	},
	{
		"label": "Antiguas",
		"value": '7'
	}
]

export interface ISelect {
	totalPropiedades: number;
	handleChange: (event: SyntheticEvent<Element>, newValue: number) => void;
	value: number;
	tipoOperacionFamilia: string;
	tipoPropiedadFamilia: string;
	containerClassName?: string;
	hideViewTabs?: boolean;
}

export const OrdenarPor = ({ totalPropiedades, handleChange, value, tipoOperacionFamilia, tipoPropiedadFamilia, containerClassName, hideViewTabs }: ISelect) => {

	const dispatch = useAppDispatch();
	const order = useAppSelector(selectFilter).order
	const styleName = containerClassName && containerClassName !== '' ? styles[containerClassName] : styles.contador;

	const _HandlerOrderByOptions = (event: any) => {

		const orderValue = event.target.value

		dispatch(setOrder(orderValue))
	}

	const dataAttr = {"data-apartado": `${tipoOperacionFamilia} ${tipoPropiedadFamilia}`};

	return (
		<div className={styles.cPrincipal}>
			<div className={styleName}>Estás viendo {separadorDeMiles(totalPropiedades)} propiedades.</div>
			{!hideViewTabs && (
				<TabsStyled square sx={{ display: { xs: 'none', md: 'block' } }} >
					<Tabs className='tabs-container' value={value} onChange={handleChange} >
						<Tab disableRipple id="list" data-apartado={`${tipoOperacionFamilia} ${tipoPropiedadFamilia}`} data-elemento="lista"  icon={<Icon className="icono" color={value === 0 ? '#3200c1' : '#B1B1B1'} name="List" size={16} />} iconPosition="start" label="Lista" />
						<Tab disableRipple id="grid" data-apartado={`${tipoOperacionFamilia} ${tipoPropiedadFamilia}`} data-elemento="grilla" icon={<Icon className="icono" color={value !== 0 ? '#3200c1' : '#B1B1B1'} name="Grid" size={16} />} iconPosition="start" label="Grilla" />
					</Tabs>
				</TabsStyled>
			)}
			<div className={styles.cSelect}><Select label="Ordenar por:" name="ordenar-por" options={orderByOptions} onChange={_HandlerOrderByOptions} value={order} size='small' {...dataAttr} /></div>
		</div>
	)
}

const TabsStyled = styled(Paper)((theme) => ({
	boxShadow: 'none',
	margin: '0 16px',
	backgroundColor: '#F9F9F9',
	width: '20%',
	'.MuiTabs-indicator': {
		backgroundColor: '#3200c1',
		height: '4px',
		borderRadius: '4px',
	},
	'.MuiTab-root': {
		textTransform: 'none',
		color: '#B1B1B1',
		fontFamily:'nunito',
		'&.Mui-selected': {
			color: '#3200c1 !important',
		}
	},
	'.MuiButtonBase-root': {
		'&.MuiTab-root': {
			minHeight: '56px',
			'& svg': {
				marginRight: '8px !important'
			}
		},
	},
}))